import React from 'react';
import { Check } from 'lucide-react';
import { Reveal, SectionEyebrow, SectionTitle, Container } from './Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const Advantages = () => {
  const { t } = useLanguage();
  return (
    <section
      id="advantages"
      data-testid={SITE.sectionAdvantages}
      className="relative py-20 lg:py-32 bg-white"
    >
      <Container>
        <div className="max-w-2xl">
          <Reveal>
            <SectionEyebrow>{t.advantages.eyebrow}</SectionEyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <SectionTitle className="mt-4">{t.advantages.title}</SectionTitle>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {t.advantages.items.map((label, i) => (
            <Reveal key={label} delay={(i % 4) * 0.05}>
              <div
                data-testid={SITE.advantageItem}
                className="h-full flex items-start gap-3 p-5 rounded-2xl bg-[#F7F8F5] border border-transparent hover:border-[rgba(0,166,81,0.3)] hover:bg-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_30px_-12px_rgba(0,166,81,0.25)]"
              >
                <div className="shrink-0 w-7 h-7 rounded-lg bg-[#00A651]/10 flex items-center justify-center mt-0.5">
                  <Check size={15} className="text-[#00A651]" strokeWidth={3} />
                </div>
                <span className="text-sm font-medium text-[#0B0F0C] leading-snug">
                  {label}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.25}>
          <div className="mt-14 flex justify-center">
            <a
              href="#contact"
              data-testid={SITE.advantagesCta}
              className="inline-flex items-center justify-center bg-[#00A651] hover:bg-[#22C55E] text-white font-semibold py-3.5 px-8 rounded-xl transition-all duration-300 hover:-translate-y-0.5 shadow-[0_12px_30px_-8px_rgba(34,197,94,0.5)]"
            >
              {t.advantages.cta}
            </a>
          </div>
        </Reveal>
      </Container>
    </section>
  );
};

export default Advantages;
